import * as React from 'react';
import { ReportingTab } from 'types/reporting.type';
import Bordereau from 'views/Reporting/components/PPReports/Bordereau/Bordereau';
import FinancialControl from 'views/Reporting/components/PPReports/FinancialControl/FinancialControl';
import Accumulations from 'views/Reporting/components/PPReports/Accumulations/Accumulations';
import AgentSummaryTable from 'views/Reporting/components/PPReports/AgentSummaryTable/AgentSummaryTable';
import { AUTH_GROUPS } from 'constants/index';
import LocationCluster from 'views/Reporting/components/PPReports/LocationClusters/LocationCluster';
import RenewalReport from 'views/Reporting/components/PPReports/Renewal/RenewalReport';
import Inspections from 'views/Reporting/components/PPReports/Inspections/Inspections';
import ReferralReport from 'views/Reporting/components/PPReports/Referral/ReferralReport';
import ProductionReport from 'views/Reporting/components/PPReports/Production/ProductionReport';
import AverageRateReport from 'views/Reporting/components/PPReports/AverageRates/AverageRateReport';
import DownloadReports from 'views/Reporting/components/PPReports/Downloads/DownloadReports';
import InForceReport from 'views/Reporting/components/PPReports/InForce/InForceReport';
import LossReport from 'views/Reporting/components/PPReports/LossReport/LossReport';

const reportingTabs = {
    BORDEREAU: { label: 'Bordereau', component: <Bordereau key={'Bordereau_tab'} /> },
    PRODUCTION: {
        label: 'Production',
        component: <ProductionReport key={'ProductionReport_tab'} reportName={'Production'} />,
    },
    IN_FORCE: { label: 'Scorecard', component: <InForceReport key={'InForceReport_tab'} reportName={'Scorecard'} /> },
    DOWNLOADS: {
        label: 'Downloads',
        component: <DownloadReports key={'DownloadReports_tab'} reportName={'Downloads'} />,
    },
    FINANCIAL_CONTROL: {
        label: 'Financial Control',
        component: <FinancialControl key={'FinancialControl_tab'} reportName={'Financial Control'} />,
    },
    ACCUMULATIONS: {
        label: 'Accumulations',
        component: <Accumulations key={'Accumulations_tab'} reportName={'Accumulations'} />,
    },
    AGENT_SUMMARY: {
        label: 'Agent Summary',
        component: <AgentSummaryTable key={'AgentSummaryTable_tab'} reportName={'Agent Summary'} />,
    },
    INSPECTION: { label: 'Inspection', component: <Inspections key={'Inspections_tab'} reportName={'Inspection'} /> },
    LOCATION_CLUSTERS: {
        label: 'Location Clusters',
        component: <LocationCluster key={'LocationCluster_tab'} reportName={'Location Clusters'} />,
    },
    RENEWAL_REPORT: {
        label: 'Renewal Report',
        component: <RenewalReport key={'RenewalReport_tab'} reportName={'Renewal Report'} />,
    },
    REFERRAL_REPORT: {
        label: 'Referral Report',
        component: <ReferralReport key={'ReferralReport_tab'} reportName={'Referral Report'} />,
    },
    AVG_RATE_REPORT: {
        label: 'Average Rates',
        component: <AverageRateReport key={'AverageRateReport-tab'} reportName={'Average Rates'} />,
    },
    REPORTING_MAP: { label: 'Map', component: null },
    LOSS_REPORT: { label: 'Loss Report', component: <LossReport key={'LossReport-tab'} reportName={'Loss Report'} /> },
};

const adminTabs = [
    reportingTabs.PRODUCTION,
    reportingTabs.RENEWAL_REPORT,
    reportingTabs.LOSS_REPORT,
    reportingTabs.IN_FORCE,
    reportingTabs.AVG_RATE_REPORT,
    reportingTabs.AGENT_SUMMARY,
    reportingTabs.REFERRAL_REPORT,
    reportingTabs.LOCATION_CLUSTERS,
    reportingTabs.DOWNLOADS,
    reportingTabs.ACCUMULATIONS,
    reportingTabs.INSPECTION,
    reportingTabs.FINANCIAL_CONTROL,
];
const carrierRepTabs = [reportingTabs.ACCUMULATIONS];

const accountManagerTabs = [
    reportingTabs.PRODUCTION,
    reportingTabs.RENEWAL_REPORT,
    reportingTabs.LOSS_REPORT,
    reportingTabs.IN_FORCE,
    reportingTabs.AVG_RATE_REPORT,
    reportingTabs.AGENT_SUMMARY,
    reportingTabs.REFERRAL_REPORT,
    reportingTabs.LOCATION_CLUSTERS,
    reportingTabs.DOWNLOADS,
    reportingTabs.ACCUMULATIONS,
    reportingTabs.INSPECTION,
];

const getAvailableReportingTabs = (group: string) => {
    switch (group) {
        case AUTH_GROUPS.ADMIN:
            return adminTabs;
        case AUTH_GROUPS.CARRIER_REP:
            return carrierRepTabs;
        case AUTH_GROUPS.UNDERWRITER:
        case AUTH_GROUPS.ACCOUNT_MANAGER:
            return accountManagerTabs;
        default:
            return [];
    }
};

export const getReportingTabs = (group: string): ReportingTab[] => {
    return getAvailableReportingTabs(group);
};
